import axios from 'axios'
import { apiDomain } from '../../store/constants'

const stationList = {
    getStationList() {
        return axios({
            url: apiDomain + '/api/get-stations-detail',
            method: 'GET',
            params: {

            }
        }).catch(err => {
            console.log('Catch error ' + err)
        })
    }
}

export default stationList